export default [
    {
        display: 'HOME',
        path: '/', 
        public: true,
    },
    {
        display: 'CREA NUOVO PROGETTO',
        path: '/nuovo-progetto',
        public: false,
    },
    {
        display: 'LAVORATORI',
        path: '/lavoratori',
        public: false,
    },
    {
        display: 'ARCHIVIO PROGETTI',
        path: '/archivio-progetti',
        public: false,
    },
    {
        display: 'I MIEI PROGETTI',
        path: '/i-miei-progetti',
        public: true
    },
    {
        display: 'LE MIE BUSTE PAGA',
        path: '/buste-paga',
        public: true
    },
    {
        display: 'IMPOSTAZIONI',
        path: '/impostazioni',
        public: false
    },
    
]